<template>
	<div class="text-left font-Inter">
		<p class="text-xs font-medium text-won-green">
			Talk to Our Team
		</p>

		<h2 class="mt-0.5 text-xl leading-7 font-semibold text-won-blue">
			Second-guessing your resume?
		</h2>

		<p class="mt-2 text-sm leading-5 text-won-secondary">
			We've watched a lot of people go through this. The ones who get hired aren't the ones with the fanciest resume - they're the ones who stopped guessing. Talk to someone on our team and get a straight answer on whether you need help.
		</p>

		<div class="mt-4 flex flex-col gap-2 rounded-lg border border-won-green-light bg-won-green-hover p-4">
			<div class="flex items-center gap-1">
				<StarIcon
					v-for="n in 5"
					:key="n"
					class="size-4 text-won-yellow"
				/>
			</div>

			<p class="text-sm leading-5 text-won-dark-blue">
				"Wonsulting really tailored my resume and highlighted my strengths. They added a lot of metrics and facts into my resume and made my achievements sound more substantial. I was offered many interviews at large corporations and eventually landed a job at Yelp!"
			</p>

			<div class="flex items-center gap-2">
				<div class="size-8 shrink-0 overflow-hidden rounded-full">
					<img
						:src="JonathanBudning"
						alt="Jonathan B."
						class="size-full object-cover"
					/>
				</div>

				<div>
					<p class="text-xs font-medium text-won-dark-blue">
						Jonathan B.
					</p>
					<p class="text-xs text-won-secondary">
						Engineering Manager @ Yelp
					</p>
				</div>
			</div>
		</div>

		<div class="mt-6 flex flex-col gap-2 px-12">
			<button
				type="button"
				class="h-9 w-full cursor-pointer rounded-md bg-won-green text-sm font-medium text-white"
				@click="() => serviceNudgesStore.nudgeCtaClickHandler(serviceNudgesStore.FEATURES.resumeAi)"
			>
				Not Sure? Talk to Us
			</button>

			<button
				type="button"
				class="h-9 w-full cursor-pointer rounded-md bg-won-sand-light text-sm font-medium text-won-dark-blue"
				@click="serviceNudgesStore.closeModal"
			>
				Maybe Later
			</button>
		</div>
	</div>
</template>

<script setup>
import { StarIcon } from '@heroicons/vue/20/solid';
import { useServicesNudges } from '../../../store/services-nudges.store';

const serviceNudgesStore = useServicesNudges();
const JonathanBudning = '/img/jonathan-budning.webp';
</script>
